import { render, staticRenderFns } from "./AutofillMeasurements.vue?vue&type=template&id=52585542&"
import script from "./AutofillMeasurements.vue?vue&type=script&lang=js&"
export * from "./AutofillMeasurements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports